module.exports = __webpack_public_path__ + "img/img9.6adc2a55.svg";